import React from "react";
import Accordion from "../home/Accordion";

const AboutAccordions = () => {
  return (
    <div id="about" className="container-fluid bg-accent py-md-5 py-3">
      <div className="container-fluid my-4 text-center py-5">
        <h2>Lo que aprenderás</h2>
        <span
          style={{
            width: "50px",
            borderTop: "2px solid var(--dark)",
            height: "5px",
            color: "transparent",
          }}
        >
          ..................................
        </span>

        <div className="row mx-0">
          <div className="col-md-6">
            <Accordion
              id="learn-left"
              icon="check-blue"
              items={[
                {
                  title: "Introducción al método TBM",
                  htmlContent:
                    "Conocerás los principios detrás de la metodología The Body Method y cómo se traduce en entrenamientos estructurados, claros y efectivos.",
                },
                {
                  title: "Fundamentos del ejercicio y anatomía funcional",
                  htmlContent:
                    "Aprenderás conceptos clave del entrenamiento, anatomía funcional, bases del movimiento, mecanismos de hipertrofia y tipos de entrenamiento, para enseñar con mayor criterio, precisión y seguridad.",
                },
                {
                  title: "Técnica y ejecución",
                  htmlContent:
                    "Aprenderás la forma correcta de realizar los ejercicios, junto con variaciones, progresiones, correcciones y errores comunes, para mejorar la calidad del movimiento y enseñar con mayor claridad y seguridad.",
                },
              ]}
            />
          </div>
          <div className="col-md-6 d-lg-block">
            <Accordion
              id="learn-right"
              icon="check-blue"
              items={[
                {
                  title: "Estructura de clase y creación de rutinas",
                  htmlContent:
                    "Aprenderás a crear clases, seleccionar ejercicios y diseñar rutinas de acuerdo con distintos objetivos, desarrollando entrenamientos completos, inteligentes y con bases comprobadas.",
                },
                {
                  title: "Adaptaciones y enseñanza multinivel",
                  htmlContent:
                    "Desarrollarás herramientas para aplicar progresiones, regresiones y variaciones según las necesidades de cada alumna.",
                },
                {
                  title: "Cueing, experiencia y comunidad",
                  htmlContent:
                    "Aprenderás a enseñar con mayor claridad, dar mejores correcciones, conectar con tus alumnas, motivarlas y crear una experiencia que vaya más allá de solo un workout.",
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAccordions;
